/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useMemo } from 'react'
import LayoutUser from '../../components/layout_user'
import FooterSecondary from '../../components/footer_secondary'
import Cover from '../../components/layout_user/cover'
import Item from '../../components/item'
import ListItemsSkeleton from '../../components/list_items_skeleton'
import { useSelector, useDispatch } from 'react-redux'
import { fetchAll } from '../../../flux/items'
import lastPosition from '../../../helpers/last_position'
import { CircularProgress, Grid, Typography, Box, Hidden, useMediaQuery } from '@material-ui/core'
import styled from 'styled-components'
import { toArray } from '../../../helpers/transformer'
import Empty from '../../components/empty'
import coverPrimarySrc from '../../../assets/coverPrimary.jpg'
import { category } from '../../../config'
import Input from '../../../admin/components/input'
import Category from './category'
import HeaderComponent from './header'
import { useLocation } from 'react-router-dom'
import paginate from '../../../helpers/paginate'
import normalize from '../../../helpers/normalize'
import ordered from '../../../helpers/order'
import CategoryMobile from './categoryMobile'

const Home = () => {
  var categoryfromLocalStorage
  try {
    categoryfromLocalStorage = window.localStorage.getItem('categorySelected')
  } catch (error) {
    categoryfromLocalStorage = null
  }

  const location = useLocation()
  const [categorySelected, setCategorySelected] = useState(categoryfromLocalStorage)
  const dispatch = useDispatch()
  var { loading, items, limit, isfinally } = useSelector(state => state.items)
  items = toArray(items).filter(item => item.isActive)
  items = ordered(items)
  const isMobile = useMediaQuery('(max-width:600px)')
  var itemsFiltered = items.filter(item => categorySelected ? item.category === categorySelected : true)
  const initialKeywords = location.search.split('?keywords=')[1]
  const [keyword, setKeyword] = useState(initialKeywords || null)
  const [firstRender, setFirstrender] = useState(true)
  const [itemsRendered, setItemsRendered] = useState([])

  // setCategorySelected and save to localstorage
  const setCategorySelectedLocalStorage = value => {
    try {
      value ? window.localStorage.setItem('categorySelected', value) : window.localStorage.removeItem('categorySelected')
    } catch (error) {
      console.error('__error__', error)
    }
    setCategorySelected(value)
  }

  // define no initialRender
  useEffect(() => { setFirstrender(false) }, [])

  // filterWithKeyWords
  if (keyword && keyword.length) {
    itemsFiltered = itemsFiltered.filter(item => normalize(item.title).includes(normalize(keyword)) || normalize(item.description).includes(normalize(keyword)))
  }

  const handleSearch = keyword => {
    if (categorySelected) setCategorySelectedLocalStorage(null)
    setKeyword(keyword)
  }

  // scroll to top
  useEffect(() => {
    const space = document.getElementById('containerMasterItems').offsetTop
    if (firstRender) return window.scrollTo(0, 0)
    window.scrollTo(0, (space - (isMobile ? 300 : 220)))
  }, [categorySelected])

  // pagination with scrolling
  useEffect(event => {
    const handleScroll = event => {
      const isInLastPosition = lastPosition(100)
      if (!loading && isInLastPosition) {
        setItemsRendered([...itemsRendered, ...next()])
      }
    }
    window.addEventListener('scroll', handleScroll)
    return event => window.removeEventListener('scroll', handleScroll)
  }, [categorySelected, keyword, loading, itemsRendered])

  const onCategoryChange = target => {
    if (target.value === 'all') return setCategorySelectedLocalStorage(null)
    setKeyword(null)
    setCategorySelectedLocalStorage(target.value)
  }

  // paginate result
  const next = useMemo(() => { return paginate(itemsFiltered, 10) }, [categorySelected, keyword, loading])
  useEffect(() => {
    setItemsRendered(next())
  }, [categorySelected, keyword, loading])

  // fetch items if not exist
  useEffect(() => {
    if ((itemsFiltered.length < limit) && !isfinally) {
      dispatch(fetchAll())
    }
  }, [itemsFiltered.length, isfinally])

  return (
    <LayoutUser>
      <Cover
        maxWidth='1350px'
        title='Solicita tus estudios en línea'
        picture={coverPrimarySrc}
        text='Ahora puedes comprar tus estudios sin salir de casa. Ponemos a tu disposición nuestras pruebas más solicitadas.'
      />
      <HeaderContaner>
        <HeaderComponent
          keyword={keyword}
          setkeyword={handleSearch}
          category={category[categorySelected]}
        />
      </HeaderContaner>
      <Container id='containerMasterItems'>
        <Menu>
          <Sticky>
            <Header>
              CATEGORÍAS
            </Header>
            <Scroll>
              {Object.keys(category).map(categoryKeyName => (
                <Category
                  open={categoryKeyName === categorySelected}
                  items={items.filter(entiti => categoryKeyName === entiti.category)}
                  key={categoryKeyName}
                  setCategory={val => { setCategorySelectedLocalStorage(val); setKeyword(null) }}
                  category={categoryKeyName}
                />
              ))}
              <Category $selected={!categorySelected} setCategory={val => { setCategorySelectedLocalStorage(val); setKeyword(null) }} header='TODOS' />
            </Scroll>
          </Sticky>
        </Menu>
        <Body>
          <Box p={{ xs: 0, md: 2 }}>
            <Hidden mdUp>
              <CategoryMobile
                categorySelected={categorySelected}
                setCategory={val => { setCategorySelectedLocalStorage(val); setKeyword(null) }}
                items={items}
              />
            </Hidden>
            <Hidden smDown>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography style={{ fontWeight: 'bold', textTransform: 'uppercase' }} variant={isMobile ? 'h6' : 'h5'}>{categorySelected ? category[categorySelected] : ''}</Typography>
                </Grid>
              </Grid>
            </Hidden>
          </Box>
          {loading && itemsRendered.length === 0 && (<ListItemsSkeleton />)}
          {itemsRendered.length > 0 && (
            <Box p={{ xs: 2, md: 0 }}>
              <Grid container spacing={isMobile ? 2 : 5}>
                {itemsRendered.map(item => (
                  <Grid key={item.id} item xs={12} sm={6} lg={4}>
                    <Item {...item} />
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}
          {!loading && !itemsRendered.length && (
            <Empty
              minHeight='300px'
              message={categorySelected ? `Aun no hay productos en la categoria ${category[categorySelected]}` : keyword ? 'No encontramos resultados de búsqueda' : 'Aun no hay productos en la tienda'}
            />
          )}
          {itemsRendered.length > 0 && loading && (
            <LoaderContent>
              <CircularProgress />
            </LoaderContent>
          )}
        </Body>
      </Container>
      <FooterSecondary />
    </LayoutUser>
  )
}

const Sticky = styled.div`
  position: sticky;
  top: 150px;
`
const Scroll = styled.div`
  max-height: 60vh;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none
  }
`

const Body = styled.div`
  width: 70%;
  @media (max-width:960px) {
    width: 100%;
  }
`
const Menu = styled.div`
  width: 28%;
  @media (max-width:960px) {
    display: none;
  }
`

const LoaderContent = styled.div`
  padding: 50px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
`
const HeaderContaner = styled.div`
  padding: 10px;
  width: 85%;
  max-width: 85%;
  margin: auto;
  @media (max-width:950px) {
    width: 95%;
    max-width: 95%;
  }
`

const Container = styled(HeaderContaner)`
  display: flex;
  justify-content: space-between;
  align-content: flex-start;
`

const Header = styled.div`
  background: #f3f5f7;
  padding: 10px;
  border-radius: 5px;
  font-size: 1.1em;
  margin-bottom: 20px;
  font-weight: bold;
`
export default Home
